export const versionCodeToChunksWithLength = (code: number, size: number):string[] => {
    let str = `${code}`
    let chunks:string[] = [];

    let currentChunk:string[] = [];
    for(let i=str.length; i >= 0; --i)
    {
        currentChunk.push(str[i]);
        if(currentChunk.join('').length == size)
        {
            chunks.push(currentChunk.reverse().join(''))
            currentChunk = [];
        }
    }
    if(currentChunk.join('').length > 0)
    {
        chunks.push(currentChunk.reverse().join(''))
        currentChunk = [];
    }

    chunks = chunks.reverse();

    return chunks ?? [];
}
export const versionCodeToString = (code: number, padding: number):string => {
    return versionCodeToChunksWithLength(code, padding).map(x=>Number.parseInt(x)).join('.')
}